import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Footer from "../components/webpage/Footer";

const Contact = () => {
  const [formStatus, setFormStatus] = useState(null); // 'success' | 'error' | null
  const [loading, setLoading] = useState(false);
  const [isConsentGiven, setIsConsentGiven] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);
  
    const form = e.target;
    const name = form.elements["name"].value;
    const email = form.elements["email"].value;
    const reason = form.elements["reason"].value;
    const subject = form.elements["subject"].value;
    const message = form.elements["message"].value;
  
    try {
      const res = await fetch("https://server229256.nazwa.pl/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, reason, subject, message }),
      });
  
      if (res.ok) {
        setFormStatus("success");
        form.reset();
        setIsConsentGiven(false);
      } else {
        setFormStatus("error");
      }
    } catch (err) {
      console.error("Error sending contact form:", err);
      setFormStatus("error");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <Navbar />
      <Container>
        <Title>Skontaktuj się z nami</Title>
  
        <EmailInfo>
          Masz pytania? Napisz do nas na:{" "}
          <EmailLink href="mailto:biuro@analizyiraporty.pl">
            biuro@analizyiraporty.pl
          </EmailLink>
        </EmailInfo>
  
        <FormWrapper>
          <Form onSubmit={handleSubmit}>
            <FieldGroup>
              <Label>Imię i nazwisko</Label>
              <Input
                name="name"
                type="text"
                placeholder="Wpisz swoje imię i nazwisko"
                required
              />
            </FieldGroup>
  
            <FieldGroup>
              <Label>Email</Label>
              <Input
                name="email"
                type="email"
                placeholder="Wpisz swój email"
                required
              />
            </FieldGroup>
  
            <FieldGroup>
              <Label>Powód kontaktu</Label>
              <Select name="reason" required>
  <option value="">Wybierz opcję</option>
  <option value="demo">Zarezerwuj DEMO</option>
  <option value="problem">Zgłoszenie problemu</option>
  <option value="info">Zapytanie o informacje</option>
  <option value="partner">
    Partner
  </option>
              </Select>
            </FieldGroup>
  
            <FieldGroup>
              <Label>Temat</Label>
              <Input
                name="subject"
                type="text"
                placeholder="Temat wiadomości"
                required
              />
            </FieldGroup>
  
            <FieldGroup>
              <Label>Wiadomość</Label>
              <Textarea
                name="message"
                rows="5"
                placeholder="Twoja wiadomość..."
                required
              />
            </FieldGroup>
  
            <FieldGroup>
              <label>
                <input
                  type="checkbox"
                  checked={isConsentGiven}
                  onChange={(e) => setIsConsentGiven(e.target.checked)}
                  required
                />{" "}
                Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z{" "}
                <EmailLink
                  href="/polityka-prywatnosci.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  polityką prywatności
                </EmailLink>
                .
              </label>
            </FieldGroup>
  
            <SubmitButton type="submit" disabled={loading || !isConsentGiven}>
              {loading ? "Wysyłanie..." : "Wyślij wiadomość"}
            </SubmitButton>
  
            {formStatus === "success" && (
  <Message $success>Wiadomość została pomyślnie wysłana!</Message>
)}
{formStatus === "error" && (
  <Message $success={false}>
    Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.
  </Message>
)}

          </Form>
        </FormWrapper>
      </Container>
      <Footer />
    </>
  );
  
};

export default Contact;




const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Message = styled.p`
  margin-top: 1rem;
  font-weight: 600;
  color: ${({ $success }) => ($success ? "#10b981" : "#ef4444")};
  background: ${({ $success }) => ($success ? "#ecfdf5" : "#fef2f2")};
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid ${({ $success }) => ($success ? "#10b981" : "#ef4444")};
  text-align: center;
  animation: ${fadeIn} 0.4s ease-in-out;
`;



const Container = styled.div`
  padding: 3rem 1rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.8);
  animation: ${fadeIn} 0.8s ease;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #1f2937;
  font-weight: bold;
`;

const FormWrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1f2937;
`;

const Input = styled.input`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  transition: 0.2s ease;

  &:focus {
    border-color: #3bc3cc;
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 195, 204, 0.2);
  }
`;

const Textarea = styled.textarea`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  transition: 0.2s ease;

  &:focus {
    border-color: #3bc3cc;
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 195, 204, 0.2);
  }
`;

const SubmitButton = styled.button`
  background-color: #3bc3cc;
  color: white;
  padding: 0.8rem 1.2rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background-color: #31aeb6;
  }

  
`;

const EmailInfo = styled.p`
  text-align: center;
  font-size: 1rem;
  color: #4b5563;
  margin-bottom: 2rem;
`;

const EmailLink = styled.a`
  color: #3bc3cc;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Select = styled.select`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  background-color: white;
  transition: 0.2s ease;

  &:focus {
    border-color: #3bc3cc;
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 195, 204, 0.2);
  }
`;

